import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
  });

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentHeroSlide, setCurrentHeroSlide] = useState(0);

  // Google Ads Conversion Tracking
  const gtag_report_conversion = (url) => {
    if (typeof window.gtag === 'undefined') {
      // Eğer gtag yüklenmemişse direkt yönlendir
      if (typeof url !== 'undefined') {
        window.location = url;
      }
      return false;
    }

    const callback = function () {
      if (typeof url !== 'undefined') {
        window.location = url;
      }
    };

    window.gtag('event', 'conversion', {
      'send_to': 'AW-17622349326/dv1NCPra_rkbEI7s_tJB',
      'value': 1.0,
      'currency': 'TRY',
      'event_callback': callback
    });

    return false;
  };

  const handlePhoneClick = (e, phoneUrl) => {
    e.preventDefault();
    gtag_report_conversion(phoneUrl);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHeroSlide((prev) => (prev === 0 ? 1 : 0));
    }, 5000); // 5 saniyede bir değişir

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
  }, [darkMode]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className={`App ${darkMode ? 'dark-mode' : ''}`}>
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-top">
            <div className="header-left">
              <div className="logo">
                <img src="/images/logo.png" alt="İstanbul Servis Merkezi" className="logo-img" />
              </div>
              <nav className="nav desktop-nav">
                <ul>
                  <li><a href="#anasayfa" onClick={closeMobileMenu}>ANASAYFA</a></li>
                  <li><a href="#kurumsal" onClick={closeMobileMenu}>KURUMSAL</a></li>
                  <li><a href="#hizmetlerimiz" onClick={closeMobileMenu}>HİZMETLERİMİZ</a></li>
                  <li><a href="#iletisim" onClick={closeMobileMenu}>İLETİŞİM</a></li>
                </ul>
              </nav>
            </div>
            <div className="header-right">
              <div className="header-phone">
                <strong>HEMEN ARA - 05437352749</strong>
              </div>
              <div className="header-buttons">
                <button className="theme-toggle" onClick={toggleDarkMode} aria-label="Toggle dark mode">
                  <span className="theme-icon">{darkMode ? '☀️' : '🌙'}</span>
                </button>
                <button 
                  className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
                  onClick={toggleMobileMenu}
                  aria-label="Toggle mobile menu"
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-slider">
          <div className={`hero-slide ${currentHeroSlide === 0 ? 'active' : ''}`}>
            <div className="hero-card hero-card-1">
              <div className="hero-card-bg" style={{backgroundImage: 'url(/images/kenburns1.png)'}}></div>
              <div className="hero-card-overlay"></div>
              <div className="hero-card-content">
                <h3>SERVİS MERKEZİ</h3>
                <div className="hero-features">
                  <p>En yakın servis</p>
                  <p>Aynı gün servis hizmeti</p>
                  <p>7/24 çağrı merkezi</p>
                </div>
                <a href="tel:05437352749" className="btn" onClick={(e) => handlePhoneClick(e, 'tel:05437352749')}>HEMEN ARAYIN - 05437352749</a>
              </div>
            </div>
          </div>
          <div className={`hero-slide ${currentHeroSlide === 1 ? 'active' : ''}`}>
            <div className="hero-card hero-card-2">
              <div className="hero-card-bg" style={{backgroundImage: 'url(/images/kenburns2.png)'}}></div>
              <div className="hero-card-overlay"></div>
              <div className="hero-card-content">
                <h3>7/24 ÇAĞRI MERKEZİ</h3>
                <p>Profesyonel uzman kadromuz ile sizlere 7/24 hizmet vermekteyiz.</p>
                <a href="tel:05437352749" className="btn" onClick={(e) => handlePhoneClick(e, 'tel:05437352749')}>HEMEN ARAYIN - 05437352749</a>
              </div>
            </div>
          </div>
          <div className="hero-dots">
            <button 
              className={`hero-dot ${currentHeroSlide === 0 ? 'active' : ''}`}
              onClick={() => setCurrentHeroSlide(0)}
              aria-label="Slide 1"
            ></button>
            <button 
              className={`hero-dot ${currentHeroSlide === 1 ? 'active' : ''}`}
              onClick={() => setCurrentHeroSlide(1)}
              aria-label="Slide 2"
            ></button>
          </div>
        </div>
      </section>

      {/* Kurumsal Section */}
      <section id="kurumsal" className="kurumsal">
        <div className="container">
          <h1>KURUMSAL</h1>
          <p className="subtitle">Bizi yakından tanıyın...</p>
          <h2>İSTANBUL SERVİS MERKEZİ</h2>
          <hr />
          <p className="description">
            Uzman ve profesyonel kadromuzla uzun yıllardır bir çok markanın ürünlerinde faaliyet gösteren firmamız beyaz eşyalarınızın bakımı ve onarımı için 7/24 hizmet vermektedir. Yetkili servis olmasakta değişen ve tamiri yapılan parçaların firmamız tarafından 1 yıl garantisi bulunmaktadır. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.
          </p>
          <div className="features">
            <div className="feature">
              <h4>Uzman Kadro</h4>
              <p>Alanında eğitim almış olan profesyonel uzman kadromuz ile beyaz eşyalarınızın servis, bakım ve yedek parça ihtiyaçlarını kaliteli ve güvenilir bir şekilde karşılıyoruz.</p>
            </div>
            <div className="feature">
              <h4>7/24 Servis Hizmeti</h4>
              <p>Profesyonel ekibimiz sayesinde sizlere haftanın 7 günü 24 saat boyunca beyaz eşya teknik servisi ve yedek parça hizmeti sunmaktayız.</p>
            </div>
            <div className="feature">
              <h4>1 Yıl Garanti</h4>
              <p>Beyaz eşya servisi ve bakımı süresince kullanılmış olan yedek parçalarımızın 1 yıl garantisi bulunmaktadır. Parçadan kaynaklı sorunlarda bizi aramanız yeterli.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Beyaz Eşya Servisi Section */}
      <section className="beyaz-esya">
        <div className="container">
          <h1>BEYAZ EŞYA SERVİSİ</h1>
          <p>İstanbul Beyaz Eşya Servisi olarak 7/24 hizmet vermekteyiz.</p>
        </div>
      </section>

      {/* Services Grid */}
      <section id="hizmetlerimiz" className="services-grid">
        <div className="container">
          <div className="service-card">
            <div className="service-image">
              <img src="/images/kombi.png" alt="Kombi Servisi" />
            </div>
            <h3>KOMBİ SERVİSİ</h3>
            <hr />
            <p>Uzman ve profesyonel kadromuzla uzun yıllardır bir çok markaya ait kombi bakımı ve onarımı için 7/24 hizmet vermekteyiz. Yetkili servis olmasakta değişen ve tamiri yapılan parçaların firmamız tarafından 1 yıl garantisi bulunmaktadır. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.</p>
            <ul className="service-features">
              <li>Uzman Kadro</li>
              <li>7/24 Servis Hizmeti</li>
              <li>1 Yıl Garanti</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-image">
              <img src="/images/klima.png" alt="Klima Servisi" />
            </div>
            <h3>KLİMA SERVİSİ</h3>
            <hr />
            <p>Uzman ve profesyonel kadromuzla uzun yıllardır bir çok markaya ait klima bakımı ve onarımı için 7/24 hizmet vermekteyiz. Yetkili servis olmasakta değişen ve tamiri yapılan parçaların firmamız tarafından 1 yıl garantisi bulunmaktadır. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.</p>
            <ul className="service-features">
              <li>Uzman Kadro</li>
              <li>7/24 Servis Hizmeti</li>
              <li>1 Yıl Garanti</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-image">
              <img src="/images/buzdolabi.png" alt="Buzdolabı Servisi" />
            </div>
            <h3>BUZDOLABI SERVİSİ</h3>
            <hr />
            <p>Uzman ve profesyonel kadromuzla uzun yıllardır bir çok markaya ait buzdolabı bakımı ve onarımı için 7/24 hizmet vermekteyiz. Yetkili servis olmasakta değişen ve tamiri yapılan parçaların firmamız tarafından 1 yıl garantisi bulunmaktadır. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.</p>
            <ul className="service-features">
              <li>Uzman Kadro</li>
              <li>7/24 Servis Hizmeti</li>
              <li>1 Yıl Garanti</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-image">
              <img src="/images/camasir.png" alt="Çamaşır Makinesi Servisi" />
            </div>
            <h3>ÇAMAŞIR MAKİNESİ SERVİSİ</h3>
            <hr />
            <p>Uzman ve profesyonel kadromuzla uzun yıllardır bir çok markaya ait çamaşır makinelerinin bakımı ve onarımı için 7/24 hizmet vermekteyiz. Yetkili servis olmasakta değişen ve tamiri yapılan parçaların firmamız tarafından 1 yıl garantisi bulunmaktadır. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.</p>
            <ul className="service-features">
              <li>Uzman Kadro</li>
              <li>7/24 Servis Hizmeti</li>
              <li>1 Yıl Garanti</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-image">
              <img src="/images/bulasik.png" alt="Bulaşık Makinesi Servisi" />
            </div>
            <h3>BULAŞIK MAKİNESİ SERVİSİ</h3>
            <hr />
            <p>Uzman ve profesyonel kadromuzla uzun yıllardır bir çok markaya ait bulaşık makinelerinin bakımı ve onarımı için 7/24 hizmet vermekteyiz. Yetkili servis olmasakta değişen ve tamiri yapılan parçaların firmamız tarafından 1 yıl garantisi bulunmaktadır. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.</p>
            <ul className="service-features">
              <li>Uzman Kadro</li>
              <li>7/24 Servis Hizmeti</li>
              <li>1 Yıl Garanti</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-image">
              <img src="/images/televizyon.png" alt="Televizyon Servisi" />
            </div>
            <h3>TELEVİZYON SERVİSİ</h3>
            <hr />
            <p>Uzman ve profesyonel kadromuzla uzun yıllardır bir çok markaya ait televizyon bakımı ve onarımı için 7/24 hizmet vermekteyiz. Yetkili servis olmasakta değişen ve tamiri yapılan parçaların firmamız tarafından 1 yıl garantisi bulunmaktadır. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.</p>
            <ul className="service-features">
              <li>Uzman Kadro</li>
              <li>7/24 Servis Hizmeti</li>
              <li>1 Yıl Garanti</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Uzman Ekip Section */}
      <section className="uzman-ekip">
        <div className="container">
          <h2>UZMAN EKİP</h2>
          <h3>1 YIL GARANTİ DESTEĞİ</h3>
          <p>
            Alanında eğitim almış olan profesyonel uzman kadromuz ile %100 müşteri memnuniyeti prensibiyle beyaz eşyalarınızın servis, bakım ve yedek parça ihtiyaçlarını kaliteli ve güvenilir bir şekilde karşılıyoruz. Profesyonel ekibimiz sayesinde sizlere haftanın 7 günü 24 saat boyunca beyaz eşya teknik servisi ve yedek parça hizmeti sunmaktayız. Firmamızın prensibi olan müşteri memnuniyetini sağlamak için sizlere yıllardır beyaz eşya servisi hizmeti sunmaya devam etmekteyiz. 7/24 Çağrı Merkezimizle hizmetinizdeyiz. Size bir telefon kadar yakın olan firmamız tecrübeli ekibiyle güvenilir ve kaliteli hizmet sunmayı hedef edinerek evinizde rahat etmenizi sağlamaktadır.
          </p>
          <blockquote>
            " Beyaz Eşya Servisi ve bakımı süresince kullanılmış olan yedek parçalarımızın 1 yıl garantisi bulunmaktadır. Parçadan kaynaklı sorunlarda bizi aramanız yeterli. "
          </blockquote>
        </div>
      </section>

      {/* Teknik Servis Hizmetlerimiz */}
      <section className="teknik-servis">
        <div className="container">
          <h1>TEKNİK SERVİS HİZMETLERİMİZ</h1>
          <p className="subtitle">Kalitemiz, siz müşterilerimizin bizden duyduğu memnuniyetle eş değerdir.</p>
          <div className="servis-list">
            <div className="servis-item">
              <h4>Kombi Servisi</h4>
              <p>Uzman ve profesyonel kadromuzla uzun yıllardır faaliyet gösteren firmamız kombi servis hizmet sunmaktadır.</p>
            </div>
            <div className="servis-item">
              <h4>Klima Servisi</h4>
              <p>Uzman ve profesyonel kadromuzla uzun yıllardır faaliyet gösteren firmamız klima servis hizmet sunmaktadır.</p>
            </div>
            <div className="servis-item">
              <h4>Buzdolabı Servisi</h4>
              <p>Uzman ve profesyonel kadromuzla uzun yıllardır faaliyet gösteren firmamız buzdolabı servisi hizmet sunmaktadır.</p>
            </div>
            <div className="servis-item">
              <h4>Çamaşır Makinesi Servisi</h4>
              <p>Uzman ve profesyonel kadromuzla uzun yıllardır faaliyet gösteren firmamız çamaşır makinesi servisi hizmet sunmaktadır.</p>
            </div>
            <div className="servis-item">
              <h4>Bulaşık Makinesi Servisi</h4>
              <p>Uzman ve profesyonel kadromuzla uzun yıllardır faaliyet gösteren firmamız bulaşık makinesi servisi hizmet sunmaktadır.</p>
            </div>
            <div className="servis-item">
              <h4>Televizyon Servisi</h4>
              <p>Uzman ve profesyonel kadromuzla uzun yıllardır faaliyet gösteren firmamız televizyon servisi hizmet sunmaktadır.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Müşteri Yorumları */}
      <section className="musteri-yorumlari">
        <div className="container">
          <h1>MUTLU MÜŞTERİLERİMİZ</h1>
          <p className="subtitle">Bizi tercih eden müşterilerimizin yorumları...</p>
          <div className="yorumlar">
            <div className="yorum">
              <blockquote>Bulaşık makinemde yaşanan sorunu aynı gün gelerek çözdüler. Teşekkürler</blockquote>
              <cite>Aysel Öztürk</cite>
            </div>
            <div className="yorum">
              <blockquote>Klimam su akıtıyordu ve soğutmuyordu. Çağrı merkezini arayarak randevu oluşturdum ve hemen gelerek anında çözüm ürettiler.</blockquote>
              <cite>Ahmet Menteşeci</cite>
            </div>
            <div className="yorum">
              <blockquote>Buzdolabımın buzlanma yapıyordu ve hemen Genel Merkez Teknik Servisi aradım. Sorunsuz şekilde tamir ve onarımını yaptılar.</blockquote>
              <cite>Hakan Kurt</cite>
            </div>
          </div>
        </div>
      </section>

      {/* İstatistikler */}
      <section className="istatistikler">
        <div className="container">
          <div className="stats-grid">
            <div className="stat">
              <h2>46</h2>
              <h4>Uzman Personel</h4>
            </div>
            <div className="stat">
              <h2>32</h2>
              <h4>Servis Aracı</h4>
            </div>
            <div className="stat">
              <h2>7/24</h2>
              <h4>Müşteri Destek Hattı</h4>
            </div>
            <div className="stat">
              <h2>%100</h2>
              <h4>Müşteri Memnuniyeti</h4>
            </div>
          </div>
        </div>
      </section>

      {/* İletişim */}
      <section id="iletisim" className="iletisim">
        <div className="container">
          <h1>İLETİŞİM BİLGİLERİMİZ</h1>
          <p className="subtitle">Size bir telefon kadar yakınız.</p>
          <div className="iletisim-grid">
            <div className="iletisim-card">
              <h3>Firma Bilgileri</h3>
              <p><strong>İSTANBUL SERVİS MERKEZİ</strong></p>
              <p><strong>Adres:</strong> İSTANBUL</p>
              <p><strong>Vergi Dairesi:</strong> -</p>
              <p><strong>Vergi Numarası:</strong> -</p>
            </div>
            <div className="iletisim-card">
              <h3>7/24 Çağrı Merkezi</h3>
              <p>Pazartesi - Cumartesi : 08:00–24:00</p>
              <p>Pazar : 09:00-21:00</p>
              <p><strong>HEMEN ARA | 05437352749</strong></p>
            </div>
          </div>
          <div className="harita-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d385395.5590032773!2d28.68252429999999!3d41.0053702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa7040068086b%3A0xe1ccfe98bc01b0d0!2zxLBzdGFuYnVs!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
              width="100%"
              height="450"
              style={{ border: 0, borderRadius: '15px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="İstanbul Haritası"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Uyarı */}
      <section className="uyari">
        <div className="container">
          <p><strong>UYARI:</strong> Bu web sitesinde adı geçen markalara ait servis hizmetleri, yetkili servis kapsamında değildir. Firmamız, <strong>bağımsız özel servisdir</strong>. Amacımız tüketiciye özel servis hizmeti sunmaktır. Yanıltıcı bir izlenim oluşturulması amaçlanmamaktadır.</p>
        </div>
      </section>

      {/* Mobile Sidebar Menu */}
      <div className={`mobile-sidebar ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-sidebar-overlay" onClick={closeMobileMenu}></div>
        <div className="mobile-sidebar-content">
          <div className="mobile-sidebar-header">
            <div className="logo">
              <img src="/images/logo.png" alt="İstanbul Servis Merkezi" className="logo-img" />
            </div>
            <button className="mobile-sidebar-close" onClick={closeMobileMenu} aria-label="Close menu">
              ✕
            </button>
          </div>
          <nav className="mobile-nav">
            <ul>
              <li><a href="#anasayfa" onClick={closeMobileMenu}>ANASAYFA</a></li>
              <li><a href="#kurumsal" onClick={closeMobileMenu}>KURUMSAL</a></li>
              <li><a href="#hizmetlerimiz" onClick={closeMobileMenu}>HİZMETLERİMİZ</a></li>
              <li><a href="#iletisim" onClick={closeMobileMenu}>İLETİŞİM</a></li>
            </ul>
          </nav>
          <div className="mobile-sidebar-footer">
            <a href="tel:05437352749" className="mobile-phone-btn" onClick={(e) => handlePhoneClick(e, 'tel:05437352749')}>
              <span>📞</span>
              <strong>05437352749</strong>
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>© Copyright 2025 İstanbul Servis Merkezi | Sitemizde yer alan markanın yetkili servisi değiliz, özel servisi olarak hizmet vermekteyiz.</p>
          <p>Created by <a href="https://www.instagram.com/kanteknoloji" target="_blank" rel="noopener noreferrer" className="footer-link">kanteknoloji</a></p>
        </div>
      </footer>

      {/* Floating Contact Buttons */}
      <div className="floating-buttons">
        <a href="tel:05437352749" className="floating-call-btn" onClick={(e) => handlePhoneClick(e, 'tel:05437352749')}>
          <div className="call-icon">📞</div>
          <div className="call-text">
            <span className="call-title">HEMEN ARA</span>
            <span className="call-number">05437352749</span>
          </div>
          <div className="pulse-ring"></div>
        </a>
        <a href="https://wa.me/905437352749?text=Merhaba,%20teknik%20servis%20hizmeti%20hakkında%20bilgi%20almak%20istiyorum." target="_blank" rel="noopener noreferrer" className="floating-whatsapp-btn">
          <div className="whatsapp-icon">💬</div>
          <div className="whatsapp-text">
            <span className="whatsapp-title">WhatsApp</span>
            <span className="whatsapp-subtitle">İletişime Geç</span>
          </div>
          <div className="pulse-ring"></div>
        </a>
      </div>
    </div>
  );
}

export default App;
